/**
 * The tooltip context's shape and the context itself, apart from
 * TooltipProvider so Fast Refresh keeps the provider file components-only.
 *
 * Not the Radix TooltipProvider App mounts (components/ui/tooltip): this
 * one is mounted only around the plant card's TemperatureForecast.
 *
 * @module tooltipContextDefinition
 */
import { createContext } from 'react';

/**
 * Type definition for the tooltip context
 * @interface
 * @property {boolean} isMobile - Whether the current viewport is mobile-sized
 * @property {boolean} isTouch - Whether the current device has touch capabilities
 * @property {string | null} activeTooltipId - ID of the currently active tooltip
 * @property {function} setActiveTooltipId - Function to update the active tooltip ID
 * @property {'light' | 'dark'} theme - Current theme mode. In fact the app's theme, cast:
 *   it can be 'grow' or 'fieldnotes' too (TooltipProvider passes useTheme's value as is).
 */
export interface TooltipContextType {
  isMobile: boolean;
  isTouch: boolean;
  activeTooltipId: string | null;
  setActiveTooltipId: (id: string | null) => void;
  theme: 'light' | 'dark';
}

/**
 * React context for tooltip functionality
 * Provides tooltip state and device capability information
 * 
 * @context
 * @type {React.Context<TooltipContextType | undefined>}
 */
export const TooltipContext = createContext<TooltipContextType | undefined>(undefined); 